import { Select } from 'components/common';
import { useSourceOptions } from 'hooks';
import { ComponentProps, useState } from 'react';
import { FindAllRoleDto } from 'types';
import { ITEM_SELECT_ALL } from 'utils';

type CallChannelSourceSelectProps = ComponentProps<typeof Select> &
  Omit<FindAllRoleDto, 'pageIndex' | 'pageSize' | 'keyword'> & {
    isAll?: boolean;
    allItemLabel?: string;
  };

const CallChannelSourceSelect = ({ allItemLabel, isAll, ...props }: CallChannelSourceSelectProps) => {
  const [keyword, setKeyword] = useState('');

  // const { data, handleLoadMore, isLoading, isFetching, hasMore, resetPage } = useSourceOptions({
  //   keyword
  // });
  // const handleSearch = (val: string) => {
  //   resetPage();
  //   setKeyword(val);
  // };
  return (
    <Select
      {...props}
      // onLoadMore={handleLoadMore}
      // loading={isLoading || isFetching}
      // hasMore={hasMore}
      filterOption={false}
      // onSearch={handleSearch}
      options={[
        ...(isAll
          ? [
              {
                ...ITEM_SELECT_ALL,
                title: allItemLabel ?? ITEM_SELECT_ALL.title,
                label: allItemLabel ?? ITEM_SELECT_ALL.title
              }
            ]
          : [])
        // ...(data || []).map((itm) => ({
        //   ...itm,
        //   label: itm.name,
        //   value: itm.value
        // }))
      ]}
    />
  );
};
export default CallChannelSourceSelect;
